export default __webpack_public_path__ + "static/media/hero_768.e075360d.jpg";